export { default } from "../.internal/themes/microchart";


// WEBPACK FOOTER //
// ../../../src/themes/microchart.ts